!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.wac = n() : e.wac = n();
}(this, function () {
  return function (e) {
    var n = {};

    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: o
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (t.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var r in e) {
        t.d(o, r, function (n) {
          return e[n];
        }.bind(null, r));
      }
      return o;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 0);
  }([function (e, n, t) {
    "use strict";

    function o(e, n) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = t.tolerance,
          r = void 0 === o ? 0 : o,
          i = t.propertyName;
      return new Promise(function (t) {
        if (e) {
          var o = null,
              u = n.charAt(0).toUpperCase() + n.slice(1),
              f = 0;
          void 0 !== e.style["Webkit" + u] && (o = "webkit" + u + "End"), void 0 !== e.style.OTransition && (o = "o" + n + "End"), void 0 !== e.style[n] && (o = n + "end"), e.clearCssEndEvent && e.clearCssEndEvent(), e.clearCssEndEvent = function () {
            e.removeEventListener(o, c);
          }, e.addEventListener(o, c);
        } else t(!1);

        function c(n) {
          if ((n.srcElement || n.target) === e) {
            if (f >= r) {
              if (i && i !== n.propertyName) return;
              e.removeEventListener(o, c), t(n);
            }

            f += 1;
          }
        }
      });
    }

    function r(e) {
      window && window.requestAnimationFrame(function () {
        window.requestAnimationFrame(e);
      });
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.setCssEndEvent = o, n.beforeCssLayout = function (e) {
      window && window.requestAnimationFrame(e);
    }, n.beforeNextCssLayout = r, n.beforeFutureCssLayout = function (e, n) {
      !function e(n, t) {
        if (window && n && Number.isInteger(n) && n > 0) return void window.requestAnimationFrame(function () {
          e(n - 1, t);
        });
        t();
      }(e + 1, n);
    }, n.onceNextCssLayout = function () {
      return new Promise(function (e) {
        r(e);
      });
    }, n.onceTransitionEnd = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return new Promise(function (t) {
        o(e, "transition", n).then(t);
      });
    }, n.onceAnimationEnd = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return new Promise(function (t) {
        o(e, "animation", n).then(t);
      });
    };
  }]);
});